let rootUri = null;

const buildUrl = path => `//${rootUri}${path}`;

export const webPortalApi = {
  init(uri) {
    rootUri = uri;
  },
  buildUrl,
  buildApiUrl: path => buildUrl(`/api/${path}`),
  buildStaticUrl: path => buildUrl(`/static/${path}`)
};
